<div class="container position-relative portailrh-container-page">
  <div class="row mb-3">
    <div class="col-8 align-self-center">
      <h2>
        Mon équipe globale
        <ng-container *ngIf="(equipeGlobaleLoading$ | async) === false">
          <ng-container *ngIf="resultsNumber === 0">
            (personne actuellement)
          </ng-container>
          <ng-container *ngIf="resultsNumber === 1">
            (1 personne)
          </ng-container>
          <ng-container *ngIf="resultsNumber > 1">
            ({{ resultsNumber }} personnes)
          </ng-container>
          :
        </ng-container>
      </h2>
    </div>
    <div class="col-4 text-end align-self-center"></div>
  </div>

  <app-filters provenance="equipe-globale"></app-filters>
    <div class="row mb-4">
        <div class="col-12">
            <div class="container-table">
                <div class="container-table">
                    <ag-grid-angular
                        class="ag-theme-quartz"
                        [columnDefs]="colDefs"
                        [defaultColDef]="defaultColDef"
                        [rowData] = "equipeGlobale$ | async"
                        [localeText]="localeFr"
                        [pagination]="resultsNumber >=20"
                        [paginationPageSize]="20"
                        [scrollbarWidth]="14"
                    >
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>
